/** Role codes / names treated as buyers in dropdowns. */
const BUYER_ROLE_TOKENS = ["buyer", "customer"];

/** Role codes / names treated as sellers in dropdowns. */
const SELLER_ROLE_TOKENS = ["seller", "supplier"];

function normalizeRoleText(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, " ");
}

function roleMatches(user, rolesById, tokens) {
  const role = rolesById?.get(String(user?.user_role_id)) || null;
  const haystack = [
    role?.user_role_code,
    role?.user_role,
    user?.user_role_code,
    user?.user_role,
  ]
    .map(normalizeRoleText)
    .filter(Boolean)
    .join(" ");

  if (!haystack) return false;
  return tokens.some((token) => haystack.includes(token));
}

export function buildRolesById(roles = []) {
  return new Map(
    (roles || []).map((role) => [String(role.user_role_id), role])
  );
}

export function isBuyerUser(user, rolesById) {
  return roleMatches(user, rolesById, BUYER_ROLE_TOKENS);
}

export function isSellerUser(user, rolesById) {
  return roleMatches(user, rolesById, SELLER_ROLE_TOKENS);
}

export function filterBuyerUsers(users = [], roles = []) {
  const rolesById = buildRolesById(roles);
  return (users || []).filter((user) => isBuyerUser(user, rolesById));
}

export function filterSellerUsers(users = [], roles = []) {
  const rolesById = buildRolesById(roles);
  return (users || []).filter((user) => isSellerUser(user, rolesById));
}

export function userDisplayName(user) {
  const name = [user?.user_title, user?.first_name, user?.last_name]
    .filter(Boolean)
    .join(" ");
  return name || "User";
}
